import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FollowupRoutingModule } from './followup-routing.module';

import { FullCalendarModule } from '@fullcalendar/angular'; // the main connector. must go first
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin
import interactionPlugin from '@fullcalendar/interaction';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { PartialsModule } from '../../partials/partials.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { FollowUpDialogComponent } from '../follow-up/follow-up-dialog/follow-up-dialog.component';
import { NewAttemptDialogComponent } from '../follow-up/new-attempt-dialog/new-attempt-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CreateWorkflowDialogComponent } from '../workflow/create-workflow-dialog/create-workflow-dialog.component';
import { AttemptListComponent } from '../follow-up/attempt-list/attempt-list.component';
import { MatChipsModule } from '@angular/material/chips';
import { SelectEntitiesDialogComponent } from '../../partials/content/general/select-entities-dialog/select-entities-dialog.component';
import { InterceptService } from '../../../core/_base/crud';
import { FollowupListComponent } from './followup-list/followup-list.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { followUpReducer } from '../../../core/follow-up/_reducers/follow-up.reducers';
import { FollowUpEffects } from '../../../core/follow-up';
import { CoreModule } from '../../../core/core.module';

FullCalendarModule.registerPlugins([
  // register FullCalendar plugins
  dayGridPlugin,
  interactionPlugin,
]);

@NgModule({
  declarations: [FollowupListComponent],
  imports: [
    CommonModule,
    FollowupRoutingModule,
    FullCalendarModule,
    StoreModule.forFeature('followUp', followUpReducer),
    EffectsModule.forFeature([FollowUpEffects]),
    PerfectScrollbarModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatAutocompleteModule,
    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatRadioModule,
    TranslateModule.forChild(),
    PartialsModule,
    MatSelectModule,
    MatCheckboxModule,
    NgxPermissionsModule.forChild(),
    MatTooltipModule,
    MatDatepickerModule,
    MatChipsModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    CoreModule,
  ],
  providers: [
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
  ],
  entryComponents: [
    CreateWorkflowDialogComponent,
    FollowUpDialogComponent,
    NewAttemptDialogComponent,
    AttemptListComponent,
    SelectEntitiesDialogComponent,
  ],
  exports: [],
})
export class FollowupModule {}
